"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.avatar.name': 'Avatar Name',
    'onboarding.avatar.setup.title': 'Setup Your Avatar',
    'onboarding.avatar.config.title': 'Avatar Configuration',
    'onboarding.avatar.name.label': 'Avatar Name',
    'onboarding.avatar.name.placeholder': 'Enter avatar name',
    'onboarding.avatar.name.required': '*',
    'onboarding.avatar.age.label': 'Avatar Age',
    'onboarding.avatar.age.placeholder': 'Enter avatar age',
    'onboarding.avatar.gender.label': 'Avatar Gender',
    'onboarding.avatar.gender.placeholder': '-- Select Gender --',
    'onboarding.avatar.gender.male': 'Male',
    'onboarding.avatar.gender.female': 'Female',
    'onboarding.avatar.voice.label': 'Avatar Voice',
    'onboarding.avatar.voice.placeholder': '-- Select Voice --',
    'onboarding.avatar.voice.loading': 'Loading voices...',
    'onboarding.avatar.voice.select_gender_first': 'Please select gender first',
    'onboarding.avatar.voice.male': 'Male Voice',
    'onboarding.avatar.voice.female': 'Female Voice',
    'onboarding.avatar.description.label': 'Avatar Description',
    'onboarding.avatar.description.placeholder': 'Describe your avatar...',
    'onboarding.avatar.model.label': 'AI Model',
    'onboarding.avatar.model.help': 'Select the AI model that will power your avatar',
    'onboarding.avatar.image.label': 'Avatar Image',
    'onboarding.avatar.image.placeholder': 'Upload avatar image...',
};
